$(document).ready(function () {
  if ($(".ajax-filter-form").length > 0) {
    var form = $(".ajax-filter-form");
    var url = form.data("url");

    form.find("input").change(function (e) {
      e.preventDefault();

      console.log(form.serialize());

      $.ajax({
        type: "GET",
        url: url,
        data: form.serialize(),
        success: function (response) {
          $(".page__body .page__content").html(response);
          var newUrl = $(".resources__all").data("url");
          history.pushState(null, null, newUrl);
        },
      });
    });
  }

  /* 
		Small screen filtering:
		- add span for angle bracket
		- open/close filter lists 
	*/
  if ($(".resources-form").length > 0 && $(window).width() < 1025) {
    $(".resources__menu .optionset label:first-child").append(
      '<span class="angle"></span>'
    );

    $(".resources__menu .optionset label:first-child").click(function () {
      if ($(this).next(".middleColumn").hasClass("open")) {
        $(this).next(".middleColumn").removeClass("open");
      } else {
        $(".resources__menu .optionset .middleColumn.open").removeClass("open");
        $(this).next(".middleColumn").addClass("open");
      }
    });
  }

  /* 
		Back to Insights button: 
		If the previous page was Insights with a filter, go back to the URL with filter
	*/
  if ($(".insights-back").length > 0) {
    $(".insights-back").click(function (evt) {
      evt.preventDefault();
      var previousURL = document.referrer;

      if (previousURL) {
        var urlSection = previousURL.split(window.location.hostname).pop();

        if (urlSection.startsWith("/insights/?")) {
          return (window.location = urlSection);
        } else {
          return (window.location = "/insights/");
        }
      } else {
        return (window.location = "/insights/");
      }
    });
  }
});
